import cn from "classnames";
import { Field } from "components/shared/form";
import { serializeReq, validateForm } from "helpers/form";
import { requiredField } from "helpers/validators";
import React, { useState } from "react";
import { setContact } from "sources/books/cargoOwners";

const config = {
    firstName: {
        label: "Фамилия",
        inputProps: { name: "firstName" },
    },
    lastName: {
        label: "Имя",
        inputProps: { name: "lastName" },
    },
    patronymic: {
        label: "Отчество",
        inputProps: { name: "patronymic" },
    },
    phoneNumber: {
        label: "Телефон",
        type: "phone",
        inputProps: { name: "phoneNumber" },
    },
    email: {
        label: "Email",
        validators: [requiredField],
        required: true,
        inputProps: { name: "email", type: "email" },
    },
};

export default function CounterpartyContactsForm(props) {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});

    const renderField = (fieldProps) => (
        <Field onChange={({ name, value }) => setData({ ...data, [name]: value })} {...fieldProps} />
    );

    const isValidForm = (state) => {
        return validateForm(config, serializeReq(state, config));
    };

    const saveData = () => {
        if (isValidForm(data)) {
            setLoading(true);
            setContact({ id: props.counterpartyId, contact: data }).then((res) => {
                if (res) {
                    props.back();
                }
                setLoading(false);
            });
        }
    };

    return (
        <div className={cn("font-size-14", { loading })}>
            {renderField({
                ...config.firstName,
                value: data.firstName ?? "",
                labelWrapper: "col-12 text-muted",
                fieldWrapper: "col-12",
            })}
            {renderField({
                ...config.lastName,
                value: data.lastName ?? "",
                labelWrapper: "col-12 text-muted",
                fieldWrapper: "col-12",
            })}
            {renderField({
                ...config.patronymic,
                value: data.patronymic ?? "",
                labelWrapper: "col-12 text-muted",
                fieldWrapper: "col-12",
            })}
            {renderField({
                ...config.phoneNumber,
                value: data.phoneNumber ?? "",
                labelWrapper: "col-12 text-muted",
                fieldWrapper: "col-12",
            })}
            {renderField({
                ...config.email,
                value: data.email ?? "",
                labelWrapper: "col-12 text-muted",
                fieldWrapper: "col-12",
            })}
            <div className="btn btn-sm btn-block btn-brand" onClick={saveData}>
                Сохранить
            </div>
        </div>
    );
}
